import React from 'react';

import classNames from './styles.module.scss';

const LoadingSkeleton = props => {
  return <div {...props} className={classNames.skeleton} />;
};

export default LoadingSkeleton;
